import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { CookiePolicy } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/cookiepolicy")({
  head: () => ({
    meta: [
      { title: "Cookiepolicy | Sellavo" },
      { name: "description", content: "Läs vilka cookies och liknande tekniker Sellavo använder, varför de behövs och hur du ändrar dina val." },
      { property: "og:title", content: "Cookiepolicy | Sellavo" },
      { property: "og:description", content: "Vilka cookies Sellavo använder och hur du styr dem." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://sellavo.com/cookiepolicy" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/cookiepolicy" }],
  }),
  component: () => (
    <LegalPage title="Cookiepolicy" intro="Här förklarar vi vilka cookies och liknande tekniker som används och hur du styr dem.">
      <CookiePolicy />
    </LegalPage>
  ),
});